<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content" style="margin-top: 13px">
      <div style="display: flex">
        <div class="info">会员信息</div>
        <div class="info" style="margin-left: 7px">/</div>
        <div>
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(item, index) in btns" :index="index.toString()" :key="index">{{ item }}</el-menu-item>
          </el-menu>
        </div>
      </div>
      <!-- <el-button
        v-for="(item, index) in btns"
        :key="index"
        :type="currentIndex == index ? 'primary' : ''"
        @click="clickbtn(index)"
      >
        {{ item }}
      </el-button> -->
      <userInfo :userObject="userObject" @getImage="getImage" @getName="getName" v-if="currentIndex == 0"></userInfo>
      <orderInfo :userId="userId" v-if="currentIndex == 1"></orderInfo>
      <couponRecord v-if="currentIndex == 2" :userId="userId"></couponRecord>
      <addressInfo :userId="userId" v-if="currentIndex == 3"></addressInfo>

      <!-- <bankCard v-if="currentIndex == 3"></bankCard> -->
      <commissionRecord :userId="userId" v-if="currentIndex == 4"></commissionRecord>
      <collectRecord v-if="currentIndex == 5"></collectRecord>
      <fansRecord :userId="userId" v-if="currentIndex == 6"></fansRecord>
      <rechargeRecord :userId="userId" v-if="currentIndex == 7"></rechargeRecord>
      <integralRecord :userId="userId" v-if="currentIndex == 8"></integralRecord>
      <cashRecord :userId="userId" v-if="currentIndex == 9"></cashRecord>

    </div>
  </div>
</template>

<script>
import userInfo from '../components/userInfo.vue'
import orderInfo from '../components/orderInfo.vue'
import addressInfo from '../components/addressInfo.vue'
import bankCard from '../components/bankCard.vue'
import commissionRecord from '../components/commissionRecord.vue'
import collectRecord from '../components/collectRecord.vue'
import fansRecord from '../components/fansRecord.vue'
import cashRecord from '../components/cashRecord.vue'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import couponRecord from '../components/couponRecord.vue'
import rechargeRecord from '../components/rechargeRecord.vue'
import integralRecord from '../components/integralRecord.vue'
export default {
  components: {
    userInfo,
    orderInfo,
    addressInfo,
    bankCard,
    cashRecord,
    commissionRecord,
    collectRecord,
    fansRecord,
    breadcrumbTop,
    couponRecord,
    rechargeRecord,
    integralRecord
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '用户管理', path: '/userManagement/userList', type: '0' },
          { title: '会员列表', path: '/userManagement/userList', type: '1' },
          { title: '会员详情', path: '', type: '2' }
        ]
      },
      activeIndex: 0 || '0',
      currentIndex: 0 || '0',
      name: '---',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ],
      btns: ['个人信息', '订单信息', '优惠券记录', '地址信息', '佣金记录', '收藏记录', '粉丝记录', '充值记录', '积分记录', '提现记录'],
      userId: null,
      userObject: {}
    }
  },
  beforeRouteEnter(to, from, next) {

    next(vm => {
      console.log('id--=', vm.$route.query.id)
      let id = vm.$route.query.id
      vm.userId = Number(id);
      vm.getInfo()
    })
  },
  created() {
    // let id = this.$route.query.id
    // this.userId = Number(id);
    // this.getInfo()

  },
  methods: {
    getName(e) {
      this.userObject.username = e;
      this.updateUserInfo()
    },
    getImage(e) {
      this.userObject.avatarUrl = e;
      this.updateUserInfo()
    },
    updateUserInfo() {
      let data = {
        id: this.userId,
        avatarUrl: this.userObject.avatarUrl,
        username: this.userObject.username
      }
      this.axios.post('/users/updateUserInfo', data)
        .then(res => {
          console.log(res)
        })
    },
    getInfo() {
      // this.axios.get('/users/getInfo?id=' + this.userId)
      //   .then(res => {
      //     console.log(res)
      //     if (res.code == 0) {
      //       if (res.data.isMember == 0) {
      //         res.data.isMemberL = '否'
      //       } else {
      //         res.data.isMemberL = '是'
      //       }
      //       this.userObject = res.data
      //     }
      //   })
      this.axios.post('/user/userInfo/myinfo', { id: this.userId })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            // if (res.data.isMember == 0) {
            //   res.data.isMemberL = '否'
            // } else {
            //   res.data.isMemberL = '是'
            // }
            this.userObject = res.data
          }
        })
    },
    clickbtn(index) {
      this.currentIndex = index
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.currentIndex = Number(key)
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  padding-top: 0 !important;
}

.info {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 0px;
  color: #303033;
  line-height: 60px;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #2d46ee;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #303033;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal>.el-menu-item {
  height: 44px;
  line-height: 60px;
  font-size: 16px;
  margin-right: 24px;
  width: 76px;
  text-align: center;
  padding: 0;
}
</style>
